// LandingFlow.jsx
import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import HeroSection from "../components/HeroSection";
import BrandsSection from "../components/BrandsSection";

const variants = {
  initialRight: { opacity: 0, x: 200 },
  center: { opacity: 1, x: 0 },
  exitLeft: { opacity: 0, x: -200 },
};

export default function LandingFlow({ currentView, setCurrentView, onRequestSelfOrder }) {
  const [showBrands, setShowBrands] = useState(false);

  return (
    <div
      className="landing"
      // ✨ allow vertical scroll; only hide horizontal overflow for the slide animation
      style={{ position: "relative", overflowX: "auto" }}
    >
      <AnimatePresence mode="wait">
        {!showBrands ? (
          <motion.div
            key="hero"
            variants={variants}
            initial="center"
            animate="center"
            exit="exitLeft"
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <HeroSection
              setCurrentView={setCurrentView}
              onRequestSelfOrder={onRequestSelfOrder}
            />
          </motion.div>
        ) : (
          <motion.div
            key="brands"
            variants={variants}
            initial="initialRight"
            animate="center"
            exit="exitLeft"
            transition={{ duration: 0.6, ease: "easeOut" }}
            // ✨ block-flow as well
            style={{ position: "relative", minHeight: "100svh", overflowY: "visible" }}
          >
            <BrandsSection onBack={() => setShowBrands(false)} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
